import { isEmpty, isNil, isObjectLike } from 'lodash';

export const isPresent = (value: any) => {
  if (isNil(value)) {
    return false;
  } else if (isObjectLike(value)) {
    return !isEmpty(value);
  }

  return !!value.toString().trim();
};
